import React from "react";
import { makeStyles, Tooltip } from "@material-ui/core";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";

export const GridModalButtons = ({
  type = "primary",
  controlJson = {},
  advButtonThemeStyle = {},
  label = "",
  id = "",
  onClick = null,
  isViewer,
  isTertiary = false,
  disabled
}) => {
  const useStyles = makeStyles((theme) => ({
    tooltip: {
      maxWidth: "260px",
      background: "#FFFFFF 0% 0% no-repeat padding-box",
      color: "black",
      border: "#70707075 1px solid",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
      fontSize: 12
    },
    arrow: {
      "&:before": {
        border: "1px solid #70707075"
      },
      color: "white",
      fontSize: 15
    },
    resetCss: {
      padding: "6px !important",
      margin: "0 !important"
    },
    primary: {
      border: (style) =>
        `${style.PrimaryButton_BorderWidth || "1px"}` +
        " solid " +
        `${style.PrimaryButton_BorderColor || style.primaryBorderColor}` +
        " !important",
      color: (style) => `${style.PrimaryButton_FontColor || style.primaryColor} !important`,
      backgroundColor: (style) => `${style.PrimaryButton_BackgroundColor || style.primaryBackgroundColor} !important`,
      borderRadius: (style) => `${style.PrimaryButton_BorderRadius || "2px"} !important`,
      fontSize: (style) => `${style.PrimaryButton_FontSize || "12px"} !important`,
      fontFamily: (style) => `${style.PrimaryButton_FontFamily || "Open Sans"} !important`,
      fontWeight: (style) => `${style.PrimaryButton_FontWeight1 || "regular"} !important`,
      fontStyle: (style) => `${style.PrimaryButton_FontStyle || "normal"} !important`,
      cursor: (style) => `${style.isViewer && !style.disabled ? "pointer" : "auto"} !important`,
  
      "&:focus": {
        boxShadow: (style) => `0 0 5px 0px ${style.PrimaryButton_BorderColor || style.primaryBorderColor} !important}`
      }
    },
    secondary: {
      border: (style) =>
        `${style.SecondaryButton_BorderWidth || "1px"}` +
        " solid " +
        `${style.isTertiary ? "#D3D3D3" : style.SecondaryButton_BorderColor || style.secondaryBorderColor}` +
        " !important",
      color: (style) => `${style.isTertiary ? "#606060" : style.SecondaryButton_FontColor || style.secondaryColor} !important`,
      backgroundColor: (style) => `${style.SecondaryButton_BackgroundColor || "#fff"} !important`,
      borderRadius: (style) => `${style.SecondaryButton_BorderRadius || "2px"} !important`,
      fontSize: (style) => `${style.SecondaryButton_FontSize || "12px"} !important`,
      fontFamily: (style) => `${style.SecondaryButton_FontFamily || "Open Sans"} !important`,
      fontWeight: (style) => `${style.SecondaryButton_FontWeight1 || "regular"} !important`,
      fontStyle: (style) => `${style.SecondaryButton_FontStyle || "normal"} !important`,
  
      "&:focus": {
        boxShadow: (style) => `0 0 5px 0px ${style.SecondaryButton_BorderColor || style.secondaryBorderColor} !important`
      }
    }
  }));

  const { t } = useTranslation();
  const { popupStyle = {} } = controlJson;
  const classes = useStyles({ ...popupStyle, ...advButtonThemeStyle, isViewer, isTertiary, disabled });

  return (
    <Tooltip
      title={isViewer ? "" : t("Read_only_actions")}
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      placement={"bottom-start"}
      arrow
    >
      <Button
        appearance={type}
        id={id}
        key={id}
        className={[classes.resetCss, type === "primary" ? classes.primary : classes.secondary].join(" ")}
        onClick={onClick}
        disabled={disabled}
      >
        {t(label || "Button")}
      </Button>
    </Tooltip>
  );
};
